import cx from 'classnames';
import React from 'react';
import styles from './ContactSellerActionsStep2.mscss';

interface OwnProps {
    showMsgsBtn: React.ReactNode;
    inline?: boolean;
}

export const ContactSellerActionsStep2: React.FunctionComponent<OwnProps> = ({
    showMsgsBtn, inline = false,
}) => {
    return showMsgsBtn ? (
        <div className={cx(
            styles.ContactSellerActionsStep2,
            inline
                ? styles['ContactSellerActionsStep2--row']
                : styles['ContactSellerActionsStep2--col'],
            !inline && styles['ContactSellerActionsStep2--needsBottomPadding'],
        )}>
            {showMsgsBtn}
        </div>
    ) : null;
};
